<mat-form-field
  [appearance]="appearance ? appearance : 'outline'"
  [class]="inputClasses ? inputClasses : ''"
>
  <mat-icon
    *ngIf="toolTip"
    matPrefix
    [matTooltip]="toolTip"
    matTooltipClass="example-tooltip-conf"
    matTooltipPosition="{{ tooltipPosition ? tooltipPosition : 'after' }}"
    >help</mat-icon
  >
  <input
    matInput
    mask="AA.AAA.AAA/AAAA-00"
    type="text"
    placeholder="XX.XXX.XXX/XXXX-XX"
    [formControl]="cnpjForm"
    #input
    (blur)="onBlur()"
    (keyup)="keyPressSubmit($event)"
  />
  <mat-label>{{ label ? label : "Empresa por CNPJ" }}</mat-label>
  <button
    matIconSuffix
    mat-icon-button
    aria-label="Buscar empresa"
    class="bg-light mr-1"
    (click)="getEmpresa(cnpjForm.value)"
    [disabled]="disabled"
    matTooltip="{{ buttonTooltip ? buttonTooltip : 'Incluir empresa' }}"
    matTooltipClass="example-tooltip-conf"
    matTooltipPosition="above"
    required
  >
    <mat-icon>{{ icon ? icon : "search" }}</mat-icon>
  </button>
  <mat-error *ngIf="cnpjForm.hasError('required') && isFocused(input)"
    >Campo Obrigatório *</mat-error
  >
  <mat-error
    *ngIf="!cnpjForm.hasError('required') && cnpjForm.hasError('invalidCNPJ')"
    >CNPJ inválido</mat-error
  >
  <app-input-loading [isLoading]="isProgress"></app-input-loading>
</mat-form-field>
